<template>
  <div>
    <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

    <b-table
      :busy="isBusy"
      :items="items"
      :fields="fields"
      no-border-collapse
      sticky-header
      responsive
      show-empty
    >

      <template #empty>
        <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
          No hay escrituras que coincidan con los criterios de búsqueda
        </b-card>
        <b-card v-else class="text-center my-2 fs-5">
          Aún no se ha agregado ninguna escritura
        </b-card>
      </template>

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Cargando datos de tabla...</strong>
        </div>
      </template>

      <template #cell(url)="data">
        <div class="d-flex justify-content-center">

          <b-button
            @click="openModalDocumentHistory(data.item.url)"
            variant="light"
            size="sm"
          >
            <b-icon variant="primary" icon="file-pdf" font-scale="1"></b-icon>
          </b-button>
        </div>
      </template>

    </b-table>
  </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { EventNames } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import { formatDateTime} from "@/plugins/complianceScripts";

export default {
  name: 'DocumentHistoryTable',

  components: {
    AlertDismiss
  },

  props: {
    id : {
      type: String,
      required: true
    }
  },

  async mounted(){
    await this.getAll();

    // refresh this because the urls get invalidated after a while
    this.intervalId = setInterval(async () => {
      this.cargandoTabla();
      await this.getAll();
      this.cargandoTabla();
    }, 60*10*1000);
  },

  data() {
    return {
      isBusy: false,

      fields: [
        { key: 'name' , label: 'Nombre'},
        { key: 'modifiedBy', label: 'Modificado por'},
        { key: 'date', label: 'Fecha de creación', formatter: formatDateTime},
        { key: 'url', label: 'Detalles', thClass:'col-1'}
      ],

      items: [],
      intervalId: null
    }
  },

  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },

  methods:{
    ...mapActions(["getAllDocumentHistory"]),

    cargandoTabla(){
      this.isBusy = ! this.isBusy;
    },

    async getAll(){
      this.cargandoTabla();
      let result = await this.getAllDocumentHistory({companyId: this.id});

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        this.cargandoTabla();
        return;
      }


      this.items = result.data.map(x => {
        return {
          ...x,
          modifiedBy: `${x.user.name} ${x.user.lastName}`
        }
      });
      this.cargandoTabla();
    },

    openModalDocumentHistory(url){
      this.$eventBus.$emit(EventNames.OpenModalShowManagedCompanyDocument, url);
    }
  }
}
</script>
<style>

</style>
